<template lang='pug' src='./footer.pug'></template>

<script>
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-128105266-1'
})
export default {
  computed: {
    props () {
      return this.$store.state.app.footer
    }
  },
  methods: {
    callGa: function (i) {
      if (i === 0) {
        console.log('Event Call')
        this.$ga.event('send', 'event', "{ eventCategory: 'Phone Call Tracking', eventAction: 'click', eventLabel: '916.461.5465', 'send_to': 'AW-810848538/tsqBCJXakPsCEJqi0oID' }")
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?733c880e